import OptedOutContactsPage from '../pages/dashboard/components/pages/OptedOutContactsPage';

export default function OptedOutRoute() {
  return <OptedOutContactsPage />;
}
